module.exports = __webpack_public_path__ + "static/images/containers/WGCWXShop/containers/WGCWXRewardsTank/images/flags/usa.159041a4.png";


//////////////////
// WEBPACK FOOTER
// ./containers/WGCWXShop/containers/WGCWXRewardsTank/images/flags/usa.png
// module id = 1085
// module chunks = 16